import { decodeSkillsTemplate } from 'models/Dictionary/SkillsTemplate';
import { ServerApi } from 'modules/api/server-api';

export const fetchSkillsTemplates = (api: ServerApi) => async () => {
  const response = await api.get('/dictionary/skill-test-templates');
  return response.data.templates.map((item: any) => decodeSkillsTemplate(item));
};
